/**
 * Currency Types
 * Type definitions for multi-currency support
 */

export enum Currency {
  USD = 'USD',
  GBP = 'GBP',
  EUR = 'EUR',
  CAD = 'CAD',
  AUD = 'AUD',
}

/**
 * Multi-currency price amounts
 * Stores price for each supported currency
 */
export interface CurrencyAmounts {
  USD: number;
  GBP: number;
  EUR: number;
  CAD: number;
  AUD: number;
}

/**
 * Stripe price IDs mapped by currency
 * Each currency has its own Stripe Price ID
 */
export interface CurrencyStripePriceIds {
  USD?: string | null;
  GBP?: string | null;
  EUR?: string | null;
  CAD?: string | null;
  AUD?: string | null;
}

/**
 * Multi-currency price entry
 * Replaces single amount/stripePriceId with currency-specific values
 */
export interface MultiCurrencyPrice {
  duration: string;
  amounts: CurrencyAmounts;
  stripePriceIds?: CurrencyStripePriceIds;
  id?: string;
}

/**
 * Currency rate stored in database
 */
export interface CurrencyRate {
  _id: string;
  currency: Currency;
  rate: number; // Rate from USD to this currency (e.g., 0.76 for GBP means 1 USD = 0.76 GBP)
  lastUpdatedBy?: string;
  lastUpdatedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * DTO for updating currency rates
 */
export interface UpdateCurrencyRateDto {
  currency: Currency;
  rate: number;
}

export interface UpdateCurrencyRatesDto {
  rates: UpdateCurrencyRateDto[];
}

